import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CardInfo from '../../../../components/cardInfo';
import { getDataReportCard } from '../../../../features/dashboardStorage/service';
import { headers } from '../../../../utils/callApi';
import './index.css';

function BodyDashboard({children}){
  const [cards, setCards] = useState([]);

  const isLoggedIn = useSelector((state) => state.account.isLoggedIn);

  useEffect(() => {
    if(isLoggedIn) {
      getDataReportCard().then(({success, data}) => {
        setCards(data);
      })
    }
  },[headers]);

  const getLinkIcon = (title) => {
    switch (title) {
      case "Tổng dung lượng đã cấp":
      case "Tổng dung lượng còn trống": {
        return "./dashboard/database_white.svg";
      }
      case "Tổng số file đã upload": {
        return "./dashboard/file_white.svg";
      }
      case "Tổng số project": {
        return "./dashboard/project_white.svg";
      }
      default: {
        return "./dashboard/database_white.svg";
      }
    }
  }


  return (
    <>
      <div className="body_container p-3">
        <div className="body_element">
          {cards.map((card, index) => {
            return (
              <span key={index}>
                <CardInfo name_card = {card.title} info={card.value} icon={getLinkIcon(card.title)}></CardInfo>
              </span>
              
            )
          })}
        </div>
        <div className="children">
          {children}
        </div>
      </div>
    </>
  );
}
export default BodyDashboard;